import campaignConfig from '../../../../campaign-config/campaign.json';

export const globalColors = campaignConfig.global?.colors || {};

export const tutorDetailsToolsConfig = campaignConfig.tutor_details?.tools || {};

export const resolveTutorDetailsToolsAsset = (asset) => asset;
